/**
 * @Author:      skyeGao
 * @Email:       yyjzp1314@126.com
 * @DateTime:    2019-03-26 21:39:04
 * @Description: Description 
 */

// import { DEFAULTIMG } from '@/utils/defaultImg';

export const DOMAIN1 = 'zgsccbs.com';
export const DOMAIN2 = `www.${DOMAIN1}`;
const protocol = location.protocol;

// api 的 base_url 8696
export const WEBSITE_BASEURL = protocol + '//dzzz.zgzx.com.cn'; // 此值同时也为视频第一帧封面地址拼接前缀
// 个人中心的website
export const WEBSITE_USERCENTER = protocol + '//zgsccbs.com/center/index.html';
// export const WEBSITE_USERCENTER = protocol + '//dev-deliver-tax-person-center.test16.zhongdianyun.com:8709:8100';



// 资源类型
export const RESOURCETYPE_CODE = {
  rsAll: 0,
  rsBook: 1,
  rsWeiCourse: 2,
  EXPERT: 3,
  TOPIC: 4,
  rsWenku: 31,
  rsAnli: 32,
  rsShicao: 33,
  rsLaw: 34,
  rsQA: 35,
  OTHER: 50,
  NOTICE: 100,
}



// WEBPACK FOOTER //
// ./src/Epub/utils/global.js